import { Container, Header } from 'components/search/ResultNotFound/components';

import ContactButton from 'components/common/ContactButton';
import FlexContainer from 'components/common/FlexContainer';
import { Helmet } from 'react-helmet';
import SearchEmptyIcon from 'components/common/SearchEmptyIcon';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export default function ResultNotFound(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <>
      <Helmet>
        <title>{`No Credit Found - ${translation.appName}`}</title>
      </Helmet>
      <Container gap={24} className='no-results-container'>
        <FlexContainer alignItems='center' gap={40}>
          <div className='no-results-icon'>
            <SearchEmptyIcon />
          </div>
          <Header className='no-results-header'>No results found</Header>
        </FlexContainer>
        <FlexContainer gap={12} className='no-results-text-container'>
          <span>Use the tabs above to see more results or try different search terms.</span>
          <span>If you still can’t find any results, contact us to discuss your credit options.</span>
        </FlexContainer>
        <div className='no-results-button'>
          <ContactButton />
        </div>
      </Container>
    </>
  );
}
